var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"text-center"},[_c('b-spinner',{staticClass:"spinner",attrs:{"variant":"primary","label":"Spinning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }